export * from './welcome.component'